import {defineStore} from "pinia";
import {nextTick, ref} from "vue";
import {useGlobalStore} from "@/store/useGlobalStore";
import {LOGO_PATH} from "@/config/constants";
import transactionRequests from "@/composables/transactions-requests/transaction-requests";

export const useTheme = defineStore('theme-store', () => {
    const isCollapsed = ref(false)
    const activeTheme = ref('light-theme');
    const isLightTheme = ref(true)
    const globalStore = useGlobalStore()

    const setActiveTheme = (interchange = true, toggable = false) => {
        if(interchange) isLightTheme.value = !isLightTheme.value
        if(isLightTheme.value) activeTheme.value = 'light-theme'
        else activeTheme.value = 'dark-theme'

        localStorage.setItem('theme-condition', isLightTheme.value)
        localStorage.setItem('theme', activeTheme.value)
        applyTheme(toggable)
    }

    const applyTheme = (isToggable = false) => {
        const app = document.querySelector('.app')
        app.classList.remove('dark-theme')
        app.classList.remove('light-theme')
        app.classList.add(activeTheme.value)

        const logo = document.querySelector('#sys_logo')
        if(logo) {
            let LOGO_TYPE = 'SYS_LOGO'
            let icon = globalStore.sys_configs?.[LOGO_TYPE] ?? null
            let config = localStorage.getItem('sys_config')
            if(config) config = JSON.parse(config)

            if(!isLightTheme.value) {
                LOGO_TYPE = 'SYS_LOGO_GOLD'
                icon = globalStore.sys_configs?.[LOGO_TYPE] ?? null
            }
            
            // coz of branding, if sidebar has dark colors, go to light icon
            if(!isToggable) {
                LOGO_TYPE = 'SYS_LOGO_GOLD'
                icon = globalStore.sys_configs?.[LOGO_TYPE] ?? null
            }

            // check if not in pinia, get from localStorage
            if(!icon) {
                icon = config?.[LOGO_TYPE] ?? null
            }

            logo.src = icon ?? LOGO_PATH

            let web_icon = document.getElementById('sys_icon')
            if(web_icon) web_icon.setAttribute('href', config?.['SYS_LOGO'] ?? LOGO_PATH)

            document.querySelector('#sys_title').textContent = (config?.['SYS_BRAND'] + ' ' + config?.['SYS_TYPE'])
                ?? (process.env.VUE_APP_SYSTEM_BRAND + ' ' + process.env.VUE_APP_SYSTEM_NAME)
        }
    }

    const themeInit = async(from = 'login') => {
        let isToggable = true
        if(localStorage.getItem('theme-condition')) {
           isLightTheme.value = localStorage.getItem('theme-condition') === 'true'
        } else isLightTheme.value = true

        // if theme is being toggled in sidebar, set toggable as false for changing of icon
        // retain gold icon due to dark sidebar
        if(from === 'sidebar') {
            isToggable = false
        }

        await nextTick(() => {
            setActiveTheme(false, isToggable)
        })

        await setSystemStyleSheet()
        const { getSystemConfiguration } = transactionRequests()
        await getSystemConfiguration()
        await setSystemStyleSheet()
    }

    const setSystemStyleSheet = async () => {
        try {
            let config = localStorage.getItem('sys_config')
            if(config) config = JSON.parse(config)

            const COLOR_CONFIGS = ['PRIMARY', 'SECONDARY', 'SIDEBAR_BG', 'LINK_HOVER',
                'SIDEBAR_TEXT', 'SIDEBAR_ACTIVE', 'SIDEBAR_ACTIVE_TEXT', 'SECONDARY-300']

            COLOR_CONFIGS.forEach(theme => {
                if(config['SYS_' + theme] ?? false) {
                    document.documentElement.style.setProperty(`--${theme.toLowerCase()}`, config['SYS_' + theme]);
                }
            })
        } catch (e) {
            console.error(e)
        }
    }

    return {
        activeTheme,
        applyTheme,
        isLightTheme,
        isCollapsed,
        setActiveTheme,
        themeInit
    }
})